import React from 'react';
import 'animate.css';
import { FaGithub } from 'react-icons/fa'; // Import the GitHub icon

const projects = [
  { name: 'Vehicle Connect', description: 'Description of Project 1', image: '/vehicle.jpeg', githubLink: 'https://github.com/nikhilbhalkar/vehicle-transport-management' },
  { name: 'Chrome Extension for Phishing Website Detection', description: 'Description of Project 2', image: '/phising.jpeg', githubLink: 'https://github.com/nikhilbhalkar/crome-extensions-for-phishing-website' },
  { name: 'Medicine Tracker', description: 'Description of Project 3', image: '/medicine.jpeg', githubLink: 'https://github.com/nikhilbhalkar/DegitalMedicineTracker-Java-JSP-Servlet' },
  { name: 'Voice Assistant', description: 'Description of Project 4', image: '/voice.jpeg', githubLink: 'https://github.com/nikhilbhalkar/flutter-voice-Assistant' },
  { name: 'OnlineMeeting App', description: 'Description of Project 5', image: '/meeting.jpeg', githubLink: 'https://github.com/nikhilbhalkar/flutter-OnlineMeeting-App' },
  { name: 'Find best Video on YouTube', description: 'Description of Project 6', image: '/youtube.jpeg', githubLink: 'https://github.com/nikhilbhalkar/to-find-best-teacher-SIH' },
  { name: 'Instagram CLone', description: 'Description of Project 7', image: '/instagram.jpeg', githubLink: 'https://github.com/nikhilbhalkar/flutter-instagram-clone' },
  { name: 'Weather App', description: 'Description of Project 8', image: '/wether.png', githubLink: 'https://github.com/nikhilbhalkar/weatherApp' },
  { name: 'Google Clone', description: 'Description of Project 9', image: '/googleclone.png', githubLink: 'https://github.com/nikhilbhalkar/flutter-google-clone' },
];

const Projects = () => (
  <section id='project'>
    <div className="min-h-screen bg-gray-900 text-white p-8">
    <h2 className="text-3xl font-bold text-center mb-8 animate__animated animate__fadeInDown">
    <span className="relative inline-block">
            My Projects
            <div className='h-2'></div>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-transparent">
              <span className="absolute bottom-0 left-0 w-full h-full bg-blue-400 animate-drawLine"></span>
            </span>
          </span>
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center ">
      {projects.map((project, index) => (
        <div
          key={project.name}
          className={`relative flex flex-col items-center p-6 bg-gray-800 rounded-lg shadow-lg animate__animated animate__fadeInLeft animate__delay-${index}s hover:scale-105 transition-transform duration-300`}
          style={{ width: '300px'  }} // Increased width
        >
          <img
            src={project.image}
            alt={project.name}
            className="mb-4 w-full h-48 object-cover rounded-lg" // Adjusted height for better aspect ratio
          />
          <p className="text-lg font-bold">{project.name}</p>
          <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-90 text-center p-4 opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-lg">
            <div>
             
              <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="mt-4 inline-block">
                <FaGithub size={32} className="text-white hover:text-gray-400 transition-colors duration-300" />
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  </section>
);

export default Projects;
